import { useState, type FormEvent } from 'react'
import { authApi } from '../api/auth'
import { ApiError } from '../api/client'
import { useAuth } from '../auth/AuthContext'

export function SetupPage() {
  const { refresh } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [submitting, setSubmitting] = useState(false)

  async function onSubmit(e: FormEvent) {
    e.preventDefault()
    setError(null)
    setSubmitting(true)
    try {
      await authApi.setup(email, password)
      await refresh()
    } catch (err) {
      if (err instanceof ApiError) {
        const body = err.body as { errors?: string[]; error?: string }
        setError(body?.errors?.join(' · ') ?? body?.error ?? `Fel ${err.status}`)
      } else {
        setError('Något gick fel. Försök igen.')
      }
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <main className="auth-container">
      <h1>Kom igång</h1>
      <p className="muted">
        Detta är förstagångsuppsättning. Du blir enda administratören —
        registrering låser sig efter detta.
      </p>

      <form onSubmit={onSubmit} noValidate>
        <div className="field">
          <label htmlFor="setup-email">E-post</label>
          <input
            id="setup-email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>

        <div className="field">
          <label htmlFor="setup-password">Lösenord (minst 12 tecken)</label>
          <input
            id="setup-password"
            type="password"
            autoComplete="new-password"
            required
            minLength={12}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <p className="muted small">
            Använd en fras du minns — långt slår tecken-krav. Efter första
            login kan du registrera en passkey (Touch ID) för snabbare
            inloggning.
          </p>
        </div>

        {error && (
          <div role="alert" className="alert-error">
            {error}
          </div>
        )}

        <button type="submit" className="primary" disabled={submitting}>
          {submitting ? 'Skapar konto…' : 'Skapa konto'}
        </button>
      </form>
    </main>
  )
}
